import { render, staticRenderFns } from "./order-point.vue?vue&type=template&id=5829a26a&scoped=true&"
import script from "./order-point.vue?vue&type=script&lang=js&"
export * from "./order-point.vue?vue&type=script&lang=js&"
import style0 from "./order-point.vue?vue&type=style&index=0&id=5829a26a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5829a26a",
  null
  
)

export default component.exports